/**
 * Per-field selector hooks for the UI store.
 *
 * Prefer these over destructuring `useUIStore()` (which subscribes to the whole
 * store and re-renders on every unrelated change). Each hook subscribes to a
 * single field, so always-mounted components (header, panel root) only re-render
 * when the value they actually use changes (#72 Q-state).
 */
import { useUIStore } from "./ui"

// Period selector
export const usePeriod = () => useUIStore((s) => s.period)
export const useSetPeriod = () => useUIStore((s) => s.setPeriod)

// Slide-in panel / bottom sheet
export const usePanel = () => useUIStore((s) => s.panel)
export const useClosePanel = () => useUIStore((s) => s.closePanel)

// Command palette
export const useOpenCommandPalette = () => useUIStore((s) => s.openCommandPalette)

// Shared file handed off from the PWA share_target landing route
export const useSharedFile = () => useUIStore((s) => s.sharedFile)
export const useSetSharedFile = () => useUIStore((s) => s.setSharedFile)
